import React, { createContext, useState, useContext } from 'react';

const LevelContext = createContext();

export const LevelProvider = ({ children }) => {
  const [selectedLevel, setSelectedLevel] = useState(
    localStorage.getItem('selectedLevel') || 'A1'
  );

  const changeLevel = (level) => {
    setSelectedLevel(level);
    localStorage.setItem('selectedLevel', level);
  };

  const levels = ['A1', 'A2', 'B1', 'B2', 'C1'];

  return (
    <LevelContext.Provider value={{ selectedLevel, changeLevel, levels }}>
      {children}
    </LevelContext.Provider>
  );
};

export const useLevel = () => {
  const context = useContext(LevelContext);
  if (!context) {
    throw new Error('useLevel must be used within LevelProvider');
  }
  return context;
};
